import { lazy, useState } from 'react';

import PropTypes from 'prop-types';

import FormModal from '#client/components/FormModal';
import { ACTIVATE_NEW_DEBIT_CARD, SETUP_DEBIT_CARD_PIN } from '#client/constants/nextUpCards';
import { FormStepProvider } from '#client/hooks/useFormStep';
import useNextUpCardsContext from '#client/hooks/useNextUpCardsContext';

import { ACTIVATE_CARD, SET_PIN } from './constants/card';

const ActivateCardForm = lazy(() => import('./components/ActivateCardForm'));
const SetPinForm = lazy(() => import('#client/components/SetPinModal/components/PinInputForm'));

export default function ActivateCardModal({ handleClose }) {
  const [currentFormStep, setCurrentFormStep] = useState(ACTIVATE_CARD);
  const { removeCardWithAnimation, addCard } = useNextUpCardsContext();

  const handleCloseWithRemoveNextUpCard = (
    // Conditionally add debit card pin NextUp after activate card
    // true for user closing the modal and not setting pin
    // false for user closing the modal after setting pin
    { shouldAddDebitCardPin } = {
      shouldAddDebitCardPin: true
    }
  ) => {
    if (currentFormStep === SET_PIN) {
      removeCardWithAnimation(
        ACTIVATE_NEW_DEBIT_CARD,
        () => {
          if (shouldAddDebitCardPin) {
            addCard({ type: SETUP_DEBIT_CARD_PIN, order: 4 });
          }
        },
        {
          isCheckCompleted: !shouldAddDebitCardPin
        }
      );
    }
    handleClose();
  };

  return (
    <FormModal handleClose={handleCloseWithRemoveNextUpCard}>
      <FormStepProvider value={{ currentFormStep, setCurrentFormStep }}>
        {currentFormStep === ACTIVATE_CARD && (
          <ActivateCardForm handleClose={handleCloseWithRemoveNextUpCard} />
        )}
        {currentFormStep === SET_PIN && (
          <SetPinForm handleClose={handleCloseWithRemoveNextUpCard} />
        )}
      </FormStepProvider>
    </FormModal>
  );
}

ActivateCardModal.propTypes = {
  handleClose: PropTypes.func.isRequired
};
